import React from 'react';
import useOrganizationGroups from '../../../../../hooks/api/useOrganizationGroups';
import { useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { useIsDisabledByParent } from '../../../../v2BaseComponents/IsDisabledProvider';
import { Form } from '../../../../v2BaseComponents/Form';
import { APITypes } from '../../../../../primary-record-types';
import GroupFields from '../../../../shared/Groups/GroupFields';

export type AddGroupScreenOwnProps = {};

export type AddGroupScreenProps = AddGroupScreenOwnProps;

const initialValues: APITypes.organizationService.CreateOrganizationGroupRequest = {
    name: '',
    description: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
};

const AddGroupScreen: React.FC<AddGroupScreenProps> = (_props) => {
    const goBack = useGoBack();
    const { isCreatingGroup, createGroup } = useOrganizationGroups({ onCreateGroupSuccess: goBack });
    const isDisabledByParent = useIsDisabledByParent(isCreatingGroup);
    return (
        <AnimateLoadedContent isLoading={isCreatingGroup}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={initialValues}
                    onSubmit={createGroup}
                    isDisabled={isDisabledByParent}
                    onCancel={goBack}
                >
                    {() => <GroupFields isDisabled={isDisabledByParent} />}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddGroupScreen);
